document.addEventListener('DOMContentLoaded', function () {
  const pdCheckbox = document.getElementById('left-and-right-prescription-values');
  const pdContainer = document.querySelector('.select-container.pupil-distance');

  if (pdCheckbox && pdContainer) {
    pdCheckbox.addEventListener('change', function() {
      if (this.checked) {
        pdContainer.classList.add('left-and-right');
      } else {
        pdContainer.classList.remove('left-and-right');
      }
    });
  }

  document.querySelectorAll('.selectBox').forEach(function (box) {
    const selected = box.querySelector('.selected');
    const arrow = box.querySelector('svg');
    const options = box.querySelector('.selectOptions');
    const optionItems = options.querySelectorAll('.selectOption');
    const defaultValue = box.getAttribute('data-default-value');

    if (optionItems.length === 0) return;

    if (defaultValue && defaultValue.trim() !== '') {
      const match = Array.from(optionItems).find(opt => opt.getAttribute('value') === defaultValue);
      if (match) {
        selected.textContent = match.textContent;
        box.setAttribute('data-value', defaultValue);
      }
    } else if (selected.textContent.trim() !== '') {
      box.setAttribute('data-value', '');
    } else {
      const firstOption = optionItems[0];
      selected.textContent = firstOption.textContent;
      box.setAttribute('data-value', firstOption.getAttribute('value'));
    }

    function openSelect() {
      box.classList.add('open');
      arrow?.classList.add('active');
    }

    function closeSelect() {
      box.classList.remove('open');
      arrow?.classList.remove('active');
    }

    function toggleOptions() {
      box.classList.contains('open') ? closeSelect() : openSelect();
    }

    box.addEventListener('click', toggleOptions);

    optionItems.forEach(function (opt) {
      opt.addEventListener('click', function () {
        selected.textContent = opt.textContent;
        box.setAttribute('data-value', opt.getAttribute('value'));
      });
    });

    document.addEventListener('click', function (event) {
      if (!box.contains(event.target)) {
        closeSelect();
      }
    });
  });
});
